// import components
import Login from '@/components/signin/Login'
import Signup from '@/components/signin/Signup'
import PasswordResetRequest from '@/components/signin/PasswordResetRequest'
import PasswordReset from '@/components/signin/PasswordReset'
export default [
  {
    path: 'login',
    component: Login
  },
  {
    path: 'signup',
    component: Signup
  },
  {
    path: 'reset',
    component: PasswordResetRequest
  },
  {
    path: 'reset/:key*',
    component: PasswordReset
  }
]
